<!-- todo: consider renaming this component to 'Glide.vue' because it is not always a carousel but sometimes a slider -->

<template>
  <article class="overflow-hidden flex flex-col gap-6 sm:gap-8 lg:gap-10">
    <vue-glide v-if="slides.length > 0" ref="slider" v-model="activeSlide" :type="type" class="max-w-full" :breakpoints="breakpoints" :gap="40" @glide:resize="onResize">
      <vue-glide-slide v-for="(slide, index) in slides" :key="index">
        <slot name="slide" :slide="slide">
          <!-- The fallback slot consists of a very simple image and link -->
          <AtomLink :url="slide.url" class="flex flex-col w-full rounded-xl overflow-hidden">
            <figure v-if="slide.image">
              <MoleculePicture :image="slide.image" />
            </figure>
          </AtomLink>
        </slot>
      </vue-glide-slide>
    </vue-glide>

    <template v-if="slides.length > currentPerView">
      <div class="flex items-center justify-center gap-8">
        <button
          class="bg-white hover:bg-app-lid--blue-prussian group rounded-full p-2 focus:pr-2 cursor-pointer focus:outline-none hover:text-white text-app-lid--blue-prussian transform transition duration-200"
          @click="slider.glide.go('<')"
        >
          <AtomIconArrowLeft class="text-app-lid--blue-prussian group-hover:text-white w-4" />
        </button>
        <div class="text-center font-bold">{{ activeSlide + 1 }}/{{ slides.length }}</div>
        <button
          class="bg-white hover:bg-app-lid--blue-prussian group rounded-full p-2 cursor-pointer focus:outline-none hover:text-white text-app-lid--blue-prussian transform transition duration-200"
          @click="slider.glide.go('>')"
        >
          <AtomIconArrowRight class="text-app-lid--blue-prussian group-hover:text-white w-4" />
        </button>
      </div>
    </template>
  </article>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

interface Props {
  slides: Array<any>
  type?: string
  breakpoints?: object
}

withDefaults(defineProps<Props>(), {
  type: 'carousel',
  breakpoints: () => ({
    639: { perView: 1 },
    1023: { perView: 2 },
    1749: { perView: 3 },
    999999: { perView: 3 },
  }),
})

const activeSlide = ref(0)
const currentPerView = ref(3)
const slider = ref<any>()

onMounted(() => {
  currentPerView.value = slider.value?.glide.settings.perView || 3
})

function onResize() {
  currentPerView.value = slider.value?.glide.settings.perView || 3
}
</script>

<style lang="scss" scoped>
@import '@glidejs/glide/dist/css/glide.core';
@import '@glidejs/glide/dist/css/glide.theme';

.glide__slides {
  display: flex;
}

.glide__slide {
  display: flex;
  height: auto !important; // necessary to overwrite standard GlideJS height 100%
}
</style>
